<template>
    <v-card
        class="dashboard-card ma-2"
        elevation="4"
    >
        <v-card-title>Claim Payments</v-card-title>
        <v-card-subtitle>by days</v-card-subtitle>
        <v-card-subtitle>
            <v-select
                :disabled="dataObject == null"
                :items="users"
                @change="assignedUserChanged"
                clearable
                item-text="value"
                item-value="key"
                label="Assigned User"
                v-model="selectedUser"
            ></v-select>
        </v-card-subtitle>

        <!--#region-=-=-=-=-=---=-=-=-=-=-=-=-=-=-CLAIM PAID IN FULL--=-=-=-=-=-=-=-=-=---=-=-=-=-=-=-=-=-=-->
        <v-divider></v-divider>
        <v-card-text>
            <h5 class="text--secondary">Claim Paid In Full</h5>
            <v-row
                align="center"
                justify="start"
            >
                <v-card
                    @click="
                        routerPush({
                            name: 'ClaimsPostSubmission',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                paymentStatus: 1,
                                agedDaysPaymentStatusMax: 7,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="light-blue lighten-2 black--text text-center"
                    dark
                >
                    <span class="header">0-7</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{dataObject.claimPaidInFull.group0_7}}</h3>
                        <span class="facevalue">
                            R {{
                            dataObject.claimPaidInFull.group0_7_Value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }}
                        </span>
                    </span>
                </v-card>

                <v-card
                    @click="
                        routerPush({
                            name: 'ClaimsPostSubmission',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                paymentStatus: 1,
                                agedDaysPaymentStatusMin: 8,
                                agedDaysPaymentStatusMax: 14,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="lime black--text text-center"
                    dark
                >
                    <span class="header">8-14</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{dataObject.claimPaidInFull.group8_14}}</h3>
                        <span class="facevalue">
                            R {{
                            dataObject.claimPaidInFull.group8_14_Value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }}
                        </span>
                    </span>
                </v-card>

                <v-card
                    @click="
                        routerPush({
                            name: 'ClaimsPostSubmission',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                paymentStatus: 1,
                                agedDaysPaymentStatusMin: 15,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="deep-orange darken-2 white--text text-center"
                    dark
                >
                    <span class="header">15+</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{dataObject.claimPaidInFull.group15_Plus}}</h3>
                        <span class="facevalue">
                            R {{
                            dataObject.claimPaidInFull.group15_Plus_Value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }}
                        </span>
                    </span>
                </v-card>
            </v-row>
        </v-card-text>
        <!--#endregion-->

        <!--#region-=-=-=-=-=---=-=-=-=-=-=-=-=-=-SHORT PAID CLAIM NO ACTION--=-=-=-=-=-=-=-=-=---=-=-=-=-=-=-=-=-=-->
        <v-divider></v-divider>
        <v-card-text>
            <h5 class="text--secondary">Short Paid Claim - No Action</h5>
            <v-row
                align="center"
                justify="start"
            >
                <v-card
                    @click="
                        routerPush({
                            name: 'ClaimsPostSubmission',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                paymentStatus: 2,
                                agedDaysPaymentStatusMax: 7,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="light-blue lighten-2 black--text text-center"
                    dark
                >
                    <span class="header">0-7</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{dataObject.shortPaidClaimNoAction.group0_7}}</h3>
                        <span class="facevalue">
                            R {{
                            dataObject.shortPaidClaimNoAction.group0_7_Value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }}
                        </span>
                    </span>
                </v-card>

                <v-card
                    @click="
                        routerPush({
                            name: 'ClaimsPostSubmission',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                paymentStatus: 2,
                                agedDaysPaymentStatusMin: 8,
                                agedDaysPaymentStatusMax: 14,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="lime black--text text-center"
                    dark
                >
                    <span class="header">8-14</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{dataObject.shortPaidClaimNoAction.group8_14}}</h3>
                        <span class="facevalue">
                            R {{
                            dataObject.shortPaidClaimNoAction.group8_14_Value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }}
                        </span>
                    </span>
                </v-card>

                <v-card
                    @click="
                        routerPush({
                            name: 'ClaimsPostSubmission',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                paymentStatus: 2,
                                agedDaysPaymentStatusMin: 15,
                                agedDaysPaymentStatusMax: 21,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="amber black--text text-center"
                    dark
                >
                    <span class="header">15-21</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{dataObject.shortPaidClaimNoAction.group15_21}}</h3>
                        <span class="facevalue">
                            R {{
                            dataObject.shortPaidClaimNoAction.group15_21_Value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }}
                        </span>
                    </span>
                </v-card>

                <v-card
                    @click="
                        routerPush({
                            name: 'ClaimsPostSubmission',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                paymentStatus: 2,
                                agedDaysPaymentStatusMin: 22,
                                agedDaysPaymentStatusMax: 30,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="orange darken-2 black--text text-center"
                    dark
                >
                    <span class="header">22-30</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{dataObject.shortPaidClaimNoAction.group22_30}}</h3>
                        <span class="facevalue">
                            R {{
                            dataObject.shortPaidClaimNoAction.group22_30_Value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }}
                        </span>
                    </span>
                </v-card>

                <v-card
                    @click="
                        routerPush({
                            name: 'ClaimsPostSubmission',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                paymentStatus: 2,
                                agedDaysPaymentStatusMin: 31,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="deep-orange darken-2 white--text text-center"
                    dark
                >
                    <span class="header">31+</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{dataObject.shortPaidClaimNoAction.group31_Plus}}</h3>
                        <span class="facevalue">
                            R {{
                            dataObject.shortPaidClaimNoAction.group31_Plus_Value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }}
                        </span>
                    </span>
                </v-card>
            </v-row>
        </v-card-text>
        <!--#endregion-->

        <!--#region-=-=-=-=-=---=-=-=-=-=-=-=-=-=-DECISION TO BE TAKEN--=-=-=-=-=-=-=-=-=---=-=-=-=-=-=-=-=-=-->
        <v-divider></v-divider>
        <v-card-text>
            <h5 class="text--secondary">Decision To Be Taken</h5>
            <v-row
                align="center"
                justify="start"
            >
                <v-card
                    @click="
                        routerPush({
                            name: 'ClaimsPostSubmission',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                paymentStatus: 3,
                                agedDaysPaymentStatusMax: 7,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="light-blue lighten-2 black--text text-center"
                    dark
                >
                    <span class="header">0-7</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{dataObject.decisionToBeTaken.group0_7}}</h3>
                        <span class="facevalue">
                            R {{
                            dataObject.decisionToBeTaken.group0_7_Value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }}
                        </span>
                    </span>
                </v-card>

                <v-card
                    @click="
                        routerPush({
                            name: 'ClaimsPostSubmission',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                paymentStatus: 3,
                                agedDaysPaymentStatusMin: 8,
                                agedDaysPaymentStatusMax: 14,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="lime black--text text-center"
                    dark
                >
                    <span class="header">8-14</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{dataObject.decisionToBeTaken.group8_14}}</h3>
                        <span class="facevalue">
                            R {{
                            dataObject.decisionToBeTaken.group8_14_Value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }}
                        </span>
                    </span>
                </v-card>

                <v-card
                    @click="
                        routerPush({
                            name: 'ClaimsPostSubmission',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                paymentStatus: 3,
                                agedDaysPaymentStatusMin: 15,
                                agedDaysPaymentStatusMax: 21,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="amber black--text text-center"
                    dark
                >
                    <span class="header">15-21</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{dataObject.decisionToBeTaken.group15_21}}</h3>
                        <span class="facevalue">
                            R {{
                            dataObject.decisionToBeTaken.group15_21_Value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }}
                        </span>
                    </span>
                </v-card>

                <v-card
                    @click="
                        routerPush({
                            name: 'ClaimsPostSubmission',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                paymentStatus: 3,
                                agedDaysPaymentStatusMin: 22,
                                agedDaysPaymentStatusMax: 30,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="orange darken-2 black--text text-center"
                    dark
                >
                    <span class="header">22-30</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{dataObject.decisionToBeTaken.group22_30}}</h3>
                        <span class="facevalue">
                            R {{
                            dataObject.decisionToBeTaken.group22_30_Value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }}
                        </span>
                    </span>
                </v-card>

                <v-card
                    @click="
                        routerPush({
                            name: 'ClaimsPostSubmission',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                paymentStatus: 3,
                                agedDaysPaymentStatusMin: 31,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="deep-orange darken-2 white--text text-center"
                    dark
                >
                    <span class="header">31+</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{dataObject.decisionToBeTaken.group31_Plus}}</h3>
                        <span class="facevalue">
                            R {{
                            dataObject.decisionToBeTaken.group31_Plus_Value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }}
                        </span>
                    </span>
                </v-card>
            </v-row>
        </v-card-text>
        <!--#endregion-->

        <!--#region-=-=-=-=-=---=-=-=-=-=-=-=-=-=-COMMUNICATION TO SP--=-=-=-=-=-=-=-=-=---=-=-=-=-=-=-=-=-=-->
        <v-divider></v-divider>
        <v-card-text>
            <h5 class="text--secondary">Communication To SP</h5>
            <v-row
                align="center"
                justify="start"
            >
                <v-card
                    @click="
                        routerPush({
                            name: 'ClaimsPostSubmission',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                paymentStatus: 5,
                                agedDaysPaymentStatusMax: 7,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="light-blue lighten-2 black--text text-center"
                    dark
                >
                    <span class="header">0-7</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{dataObject.communicationToSP.group0_7}}</h3>
                        <span class="facevalue">
                            R {{
                            dataObject.communicationToSP.group0_7_Value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }}
                        </span>
                    </span>
                </v-card>

                <v-card
                    @click="
                        routerPush({
                            name: 'ClaimsPostSubmission',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                paymentStatus: 5,
                                agedDaysPaymentStatusMin: 8,
                                agedDaysPaymentStatusMax: 14,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="lime black--text text-center"
                    dark
                >
                    <span class="header">8-14</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{dataObject.communicationToSP.group8_14}}</h3>
                        <span class="facevalue">
                            R {{
                            dataObject.communicationToSP.group8_14_Value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }}
                        </span>
                    </span>
                </v-card>

                <v-card
                    @click="
                        routerPush({
                            name: 'ClaimsPostSubmission',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                paymentStatus: 5,
                                agedDaysPaymentStatusMin: 15,
                                agedDaysPaymentStatusMax: 21,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="amber black--text text-center"
                    dark
                >
                    <span class="header">15-21</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{dataObject.communicationToSP.group15_21}}</h3>
                        <span class="facevalue">
                            R {{
                            dataObject.communicationToSP.group15_21_Value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }}
                        </span>
                    </span>
                </v-card>

                <v-card
                    @click="
                        routerPush({
                            name: 'ClaimsPostSubmission',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                paymentStatus: 5,
                                agedDaysPaymentStatusMin: 22,
                                agedDaysPaymentStatusMax: 30,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="orange darken-2 black--text text-center"
                    dark
                >
                    <span class="header">22-30</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{dataObject.communicationToSP.group22_30}}</h3>
                        <span class="facevalue">
                            R {{
                            dataObject.communicationToSP.group22_30_Value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }}
                        </span>
                    </span>
                </v-card>

                <v-card
                    @click="
                        routerPush({
                            name: 'ClaimsPostSubmission',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                paymentStatus: 5,
                                agedDaysPaymentStatusMin: 31,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="deep-orange darken-2 white--text text-center"
                    dark
                >
                    <span class="header">31+</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{dataObject.communicationToSP.group31_Plus}}</h3>
                        <span class="facevalue">
                            R {{
                            dataObject.communicationToSP.group31_Plus_Value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }}
                        </span>
                    </span>
                </v-card>
            </v-row>
        </v-card-text>
        <!--#endregion-->

        <!--#region-=-=-=-=-=---=-=-=-=-=-=-=-=-=-SHORT PAYMENT ACTION--=-=-=-=-=-=-=-=-=---=-=-=-=-=-=-=-=-=-->
        <v-divider></v-divider>
        <v-card-text>
            <h5 class="text--secondary">Short Payment Action</h5>
            <v-row
                align="center"
                justify="start"
            >
                <v-card
                    @click="
                        routerPush({
                            name: 'ClaimsPostSubmission',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                paymentStatus: 4,
                                agedDaysPaymentStatusMax: 7,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="light-blue lighten-2 black--text text-center"
                    dark
                >
                    <span class="header">0-7</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{dataObject.shortPaymentAction.group0_7}}</h3>
                        <span class="facevalue">
                            R {{
                            dataObject.shortPaymentAction.group0_7_Value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }}
                        </span>
                    </span>
                </v-card>

                <v-card
                    @click="
                        routerPush({
                            name: 'ClaimsPostSubmission',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                paymentStatus: 4,
                                agedDaysPaymentStatusMin: 8,
                                agedDaysPaymentStatusMax: 14,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="lime black--text text-center"
                    dark
                >
                    <span class="header">8-14</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{dataObject.shortPaymentAction.group8_14}}</h3>
                        <span class="facevalue">
                            R {{
                            dataObject.shortPaymentAction.group8_14_Value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }}
                        </span>
                    </span>
                </v-card>

                <v-card
                    @click="
                        routerPush({
                            name: 'ClaimsPostSubmission',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                paymentStatus: 4,
                                agedDaysPaymentStatusMin: 15,
                                agedDaysPaymentStatusMax: 21,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="amber black--text text-center"
                    dark
                >
                    <span class="header">15-21</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{dataObject.shortPaymentAction.group15_21}}</h3>
                        <span class="facevalue">
                            R {{
                            dataObject.shortPaymentAction.group15_21_Value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }}
                        </span>
                    </span>
                </v-card>

                <v-card
                    @click="
                        routerPush({
                            name: 'ClaimsPostSubmission',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                paymentStatus: 4,
                                agedDaysPaymentStatusMin: 22,
                                agedDaysPaymentStatusMax: 30,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="orange darken-2 black--text text-center"
                    dark
                >
                    <span class="header">22-30</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{dataObject.shortPaymentAction.group22_30}}</h3>
                        <span class="facevalue">
                            R {{
                            dataObject.shortPaymentAction.group22_30_Value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }}
                        </span>
                    </span>
                </v-card>

                <v-card
                    @click="
                        routerPush({
                            name: 'ClaimsPostSubmission',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                paymentStatus: 4,
                                agedDaysPaymentStatusMin: 31,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="deep-orange darken-2 white--text text-center"
                    dark
                >
                    <span class="header">31+</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{dataObject.shortPaymentAction.group31_Plus}}</h3>
                        <span class="facevalue">
                            R {{
                            dataObject.shortPaymentAction.group31_Plus_Value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }}
                        </span>
                    </span>
                </v-card>
            </v-row>
        </v-card-text>
        <!--#endregion-->

        <!--#region-=-=-=-=-=---=-=-=-=-=-=-=-=-=-ARCHIVE--=-=-=-=-=-=-=-=-=---=-=-=-=-=-=-=-=-=-->
        <v-divider></v-divider>
        <v-card-text>
            <h5 class="text--secondary">Archive</h5>
            <v-row
                align="center"
                justify="start"
            >
                <v-card
                    @click="
                        routerPush({
                            name: 'ClaimsPostSubmission',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                paymentStatus: 6,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="blue-grey white--text text-center"
                    dark
                >
                    <span class="header">Total</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{ dataObject.archive }}</h3>
                        <span class="facevalue">
                            R {{
                            dataObject.archive_Value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }}
                        </span>
                    </span>
                </v-card>
            </v-row>
        </v-card-text>
        <!--#endregion-->

        <!--#region-=-=-=-=-=---=-=-=-=-=-=-=-=-=-FOOTER--=-=-=-=-=-=-=-=-=---=-=-=-=-=-=-=-=-=-->
        <v-divider></v-divider>
        <v-card-text>
            <v-row justify="end">
                <v-col
                    align-self="center"
                    cols="12"
                    md="6"
                >
                    <h5
                        class="text--secondary"
                        style="text-align: right"
                    >
                        Auto updates every
                        {{ (refreshSeconds / 60000).toString().substr(0, 4) }} minutes
                        or
                        <v-btn
                            @click="getData"
                            class="ml-1 white--text"
                            color="secondary darken-1"
                            elevation="4"
                            fab
                            x-small
                        >
                            <v-icon>mdi-refresh</v-icon>
                        </v-btn>
                    </h5>
                </v-col>
            </v-row>
        </v-card-text>
        <!--#endregion-->
    </v-card>
</template>

<script>
export default {
    name: "ManagementClaimPaymentsWidget",
    props: {
        selectedAreaProviderFilter: {
            type: Object,
            default: () => {
                return { areaId: 0, providerId: 0 };
            }
        }
    },
    data: () => ({
        dataObject: null,
        refreshTimeout: null,
        refreshSeconds: 300000,
        storeDispatch: "claims/getclaimpaymentmanagementwidgetdto",
        providerId: 0,
        areaId: 0,
        users: [],
        currentUserId: 0,
        selectedUser: null
        //
    }),
    mounted: async function() {
        this.users = await this.$store.dispatch("users/getlist");
        this.users.unshift({'key':null, 'value':"All"});
        this.currentUserId = await this.$store.dispatch("users/getCurrentUserId");
        this.selectedUser = this.currentUserId;
        this.refreshTimeout = setTimeout(this.getData, 0);
    },
    computed: {
        //
    },
    watch: {
        selectedAreaProviderFilter: function() {
            this.providerId = this.selectedAreaProviderFilter.providerId;
            this.areaId = this.selectedAreaProviderFilter.areaId;
            this.getData();
        }
    },
    methods: {
        assignedUserChanged() {
            this.refreshTimeout = setTimeout(this.getData, 0);    
        },
        routerPush(object) {
            if(this.selectedUser)
            object.params.assignedUserId = this.selectedUser
            this.$router.push(object);
        },
        getData() {
            this.stopRefreshTimeOut();
            this.dataObject = null;

            this.$store
                .dispatch(this.storeDispatch, {
                    urlParameters: {
                        providerId: this.selectedAreaProviderFilter.providerId,
                        areaId: this.selectedAreaProviderFilter.areaId,
                        assignedUserId: this.selectedUser
                    }
                })
                .then(dataResponse => {
                    this.dataObject = dataResponse;
                })
                .finally(() => {
                    this.refreshTimeout = setTimeout(
                        this.getData,
                        this.refreshSeconds
                    );
                });
        },
        stopRefreshTimeOut() {
            if (this.refreshTimeout != null) clearTimeout(this.refreshTimeout);
        }
        //--------------------
    },
    destroyed: function() {
        this.stopRefreshTimeOut();
    }
};
</script>

<style lang="stylus" scoped>
span {
    .facevalue {
        font-size: 0.54rem;
    }
}

#app.theme--light {
    span.facevalue {
        color: black !important;
    }
}

#app.theme--dark {
    span.facevalue {
        color: white !important;
    }
}
</style>
